import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { CardTitle } from "../common";
import { ProformaList } from "./ProformaList";

export const AttachedProformasCard = () => {
  return (
    <Card>
      <Card.Section>
        <CardTitle>{t`Attached proforma invoices`}</CardTitle>
        <ProformaList />
      </Card.Section>
    </Card>
  );
};
